import { render, staticRenderFns } from "./LectureExamResults.vue?vue&type=template&id=9054aaf8&"
import script from "./LectureExamResults.vue?vue&type=script&lang=js&"
export * from "./LectureExamResults.vue?vue&type=script&lang=js&"
import style0 from "./LectureExamResults.vue?vue&type=style&index=0&id=9054aaf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports